<!-- todo 客户端未用此路由；h5端未用此路由；服务端未用此路由 -->
<template>
  <div class="container-pay-result">
    <div class="content" v-if="appName == 'Vava'">
      <img v-if="status == 'SUCCESS'" src="@/assets/packageAssets/views/P1_Boys/PayResult/default/pay_succ_vava.png" alt="" />
      <img v-if="status == 'FAILED' || status == 'CLOSED'" src="@/assets/packageAssets/views/P1_Boys/PayResult/default/pay_fail_vava.png" alt="" />
    </div>
    <div class="content" v-if="appName == 'JoyChat'">
      <img v-if="status == 'SUCCESS'" src="@/assets/packageAssets/views/P1_Boys/PayResult/default/pay_succ_joychat.png" alt="" />
      <img v-if="status == 'FAILED' || status == 'CLOSED'" src="@/assets/packageAssets/views/P1_Boys/PayResult/default/pay_fail_joychat.png" alt="" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    const query = this.$route.query
    return {
      status: query.status,
      appName: query.appName,
    }
  },
}
</script>

<style lang="less" scoped>
.container-pay-result {
  width: 100%;
  height: 100vh;
  .content {
    width: 100%;
    height: 100vh;
    overflow: hidden;
    > img {
      width: 100%;
      height: 100vh;
      object-fit: cover;
    }
  }
}
</style>
